import { useCallback, useState } from "react";
import { useTranslation } from 'react-i18next';
import DialogBox from "../../../core-components/theme/components/DialogBox/DialogBox";
import FileConflictComponent from "../../../globalComponents/FileConflictComponent";
import { Box, CircularProgress, FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import Button from "../../../core-components/theme/components/Button/Button";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Neutrals } from "../../../core-components/theme/color-palette/colors";

const FMSFileConflictDialog = ({filesCollection, handleClose, handleFileConflictStatus, isLoading}: any) => {
  const { t } = useTranslation();
  const [mode, setMode] = useState<'replace' | 'rename'>('replace');

  const renderTitle = useCallback(() => {
    return (
      <Box display="flex" alignItems="center" gap={1}>
      <WarningAmberIcon sx={{ color: Neutrals[600]}} />
      <Typography variant="body1" sx={{ fontWeight: 600, color: Neutrals[600] }}>{t('fileManager.fileAlreadyExists', 'File Already Exists')}</Typography>
    </Box>
    )
  }, []);
 

  return (
    <DialogBox width="100%" open={true} handleClose={() => !isLoading && handleClose()} title={renderTitle()} maxWidth="368px" >
      <Stack rowGap={6}>
        {
          filesCollection?.length> 0 && (
            <FileConflictComponent
              files={filesCollection}
            />
          )
        }
        <RadioGroup value={mode} onChange={(e) => setMode(e.target.value as 'replace' | 'rename')} sx={{rowGap: '4px', paddingLeft: '10px'}}>
          <FormControlLabel
            value="replace"
            control={<Radio />}
            label={
              <Stack>
                <Typography variant="h4">{t('fileManager.replaceExistingFile', 'Replace existing file')}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {t('fileManager.existingFileWillBeDeleted', 'Existing file will be permanently deleted')}
                </Typography>
              </Stack>
            }
          />

          <FormControlLabel
              value="rename"
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="h4">{t('fileManager.renameAndKeepBothFiles', 'Rename and Keep both files')}</Typography>
                </Box>
              }
            />
        </RadioGroup>
        <Button variant="contained" onClick={() => !isLoading && handleFileConflictStatus(mode)} disabled={isLoading}>
          {isLoading ? <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>{t('fileManager.uploading', 'Uploading')} <CircularProgress size={20} sx={{  color: 'white'}}/></Box> : t('fileManager.continue', 'Continue')}
        </Button>
      </Stack>
    </DialogBox>
  )
}

export default FMSFileConflictDialog;